<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      style="color: white"
      :title="$t('langcfg.txtPhotoPreview')"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      top="10vh"
      z-index="1000"
    >
      <img style="width: 90%; height: 90%; margin-left: 5%" :src="`file://${src}`" alt="" />

      <div class="btn-area">
        <el-button class="btn-oprator border-normal" @click="hideDialog('cancel')"
          ><span>{{ $t("langcfg.txtCancel") }}</span></el-button
        >
        <el-button v-if="isOKBtnVisible" class="btn-oprator border-normal" @click="hideDialog('OK')"
          ><span>{{ $t("langcfg.txtNext") }}</span></el-button
        >
        <el-button class="btn-oprator border-normal" @click="hideDialog('end')"
          ><span>{{ $t("langcfg.txtEndCapture") }}</span></el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "PhotoPreview",
  data() {
    return {
      visible: false
    };
  },
  props: {
    isVisible: false,
    isOKBtnVisible: true,
    src: ""
  },
  mounted() {},
  watch: {
    isVisible: {
      immediate: true,
      handler() {
        this.visible = this.isVisible;
      }
    }
  },
  methods: {
    hideDialog(value) {
      this.$emit("hide-dialog", value);
    }
  }
};
</script>
<style lang="less" scoped>
.photo-preview {
  position: absolute;
  background: red;
  z-index: 50;
}
.el-button {
  min-width: 200px;
  margin-left: 5%;
  font-size: @header-fs;
  color: white;
  i {
    font-size: @header-fs+30px;
  }
}
.btn-oprator {
  height: @header-fs+30px;
}
.btn-oprator:hover {
  color: @btn-hover-color;
  span {
    color: @btn-hover-color;
  }
}
.btn-oprator:active {
  background: @btn-active-color;
}
.border-normal :hover {
  span {
    color: @btn-hover-color;
  }
}
.btn-area {
  width: 90%;
  margin-left: 5%;
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/PhotoPreview.vue